module.exports = __webpack_public_path__ + "static/media/boomer.dbd4b013.svg";